module.exports = __webpack_public_path__ + "img/earphone.c3143e70.png";